import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
export const BlockchainManagementServiceContext = createContext(null);
export const BlockchainManagementServiceProvider = ({ children, blockchainManagementService }) => {
    return (_jsx(BlockchainManagementServiceContext.Provider, { value: { blockchainManagementService }, children: children }));
};
//# sourceMappingURL=blockchain-management-service.js.map